'use client';

import React, { useState } from 'react';

import { Switch, TextField, Typography } from 'lighthouse';

import { StarRating } from '@/widgets/StarRating';
import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { ReviewModalProps } from './models';

import { createProductReviewService } from '@/client/services/vendor/methods';
import { cornbar } from 'cornbar';

const ReviewModal = ({ open, onClose, productUuid, productTitle, orderId, subOrderId }: ReviewModalProps) => {
    const [reviewText, setReviewText] = useState('');
    const [reviewRate, setReviewRate] = useState(0);
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        onClose();
        setReviewText('');
        setReviewRate(0);
        setIsAnonymous(false);
    };

    const handleSubmit = async () => {
        if (!reviewRate) return;
        setLoading(true);
        try {
            await createProductReviewService(productUuid, {
                orderId: orderId,
                subOrderId: subOrderId,
                rate: reviewRate,
                comment: reviewText.length ? reviewText : null,
                anonymous: isAnonymous
            });
            cornbar.show({
                title: 'عملیات موفق بود',
                description: 'نظر شما ثبت شد و پس از بررسی در سایت نمایش داده خواهد شد.',
                variant: 'success'
            });
            handleClose();
        } catch {
            // API error toast is handled by the shared client errorHandler
        } finally {
            setLoading(false);
        }
    };

    return (
        <SwipeableDrawer
            open={open}
            onClose={handleClose}
            title='ثبت نظر'
            primaryActionText='ثبت نظر'
            onSubmit={handleSubmit}
            primaryActionProps={{ disabled: !reviewRate || loading, loading }}
            secondaryActionText='انصراف'
            secondaryActionProps={{ onClick: handleClose }}>
            <div className='bg-gray-50 p-4 text-right'>
                <Typography variant='body2' className='mb-3 font-bold text-gray-800'>
                    {productTitle}
                </Typography>
                <div className='mb-4 flex items-center justify-between gap-3 rounded-lg border border-solid border-gray-100 bg-white py-1 pr-2'>
                    <Typography variant='caption' className='text-gray-500'>
                        امتیاز شما <span className='text-[10px] opacity-70'>(اجباری)</span>
                    </Typography>
                    <StarRating rating={reviewRate} onChange={setReviewRate} size='md' />
                </div>
                <TextField
                    value={reviewText}
                    rows={4}
                    multiline
                    autoFocus
                    className='w-full rounded-lg bg-white'
                    placeholder='نظر خود را وارد کنید'
                    onChange={(event) => setReviewText(event.target.value)}
                />
                <div className='mt-4 flex items-center justify-between rounded-lg border border-solid border-gray-100 bg-white p-3'>
                    <div className='flex flex-col'>
                        <Typography variant='body2' className='font-medium text-gray-800'>
                            ثبت نظر به صورت ناشناس
                        </Typography>
                        <Typography variant='caption' className='text-gray-500'>
                            نام شما نمایش داده نخواهد شد
                        </Typography>
                    </div>
                    <Switch checked={isAnonymous} onChange={(event) => setIsAnonymous(event.target.checked)} />
                </div>
            </div>
        </SwipeableDrawer>
    );
};

export default ReviewModal;
